<template>
    <div class="menu" :class="color">
        <b-container>
            <b-navbar toggleable="lg">
                <b-navbar-brand href="https://www.garlans.com/"><img :src="image" alt="Logo"></b-navbar-brand>
                <b-navbar-nav class="ml-auto">
                    <p class="contact-desktop">¿NECESITAS AYUDA? <a href="tel:+17603576846">(760) 357 6846</a></p>
                    <p class="contact-mobile"><a href="tel:+17603576846"><img v-if="color" src="../assets/img/icn_phone_white.svg" alt="Phone icon"><img v-else src="../assets/img/icn_phone.svg" alt="Phone icon">(760) 357 6846</a></p>
                </b-navbar-nav>
            </b-navbar>
        </b-container>
    </div>
</template>

<script>
    export default {
        props: {
            color: {
                type: String,
                required: false
            },
            image: {
                type: String,
                default: require('../assets/img/img-logo.png'),
                required: true
            },
            position: {
                type: Boolean,
                required: false
            }
        },
    }
</script>

<style scoped>
.navbar{
    padding: 0;
}
a{
    color: #000;
    text-decoration: none;
    font-weight: bold;
}
p{
    margin-top: 1rem;
}
.menu{
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.ml-auto{
    margin-left: auto;
}
.light{
    position: absolute;
    color: #fff;
    width: 100%;
}
.light a{
    color: #fff;
    text-decoration: none;
    font-weight: bold;
}
img{
    width: 155px;
}
.contact-mobile{
    display: none;
}
@media (max-width: 1600px) {
    img{
        width: 115px;
    }
}

@media (max-width: 768px) {
    .contact-mobile{
        display: inline-flex;
    }
    .contact-mobile img{
        width: 20px;
    }
    .contact-desktop{
        display: none;
    }
}

</style>